webpackJsonp([212839066777427],{

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo_square = __webpack_require__(59);
	
	var _logo_square2 = _interopRequireDefault(_logo_square);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'nav',
	    { className: 'navbar navbar-default navbar-static-top' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container-fluid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-header' },
	        _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: 'navbar-toggle collapsed hidden-xs',
	            'data-toggle': 'collapse',
	            'data-target': '#navbar',
	            'aria-expanded': 'false',
	            'aria-controls': 'navbar'
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'sr-only' },
	            'Toggle navigation'
	          ),
	          _react2.default.createElement('span', { className: 'icon-bar' }),
	          _react2.default.createElement('span', { className: 'icon-bar' }),
	          _react2.default.createElement('span', { className: 'icon-bar' })
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'navbar-brand', href: '/' },
	          _react2.default.createElement('img', { src: _logo_square2.default })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'navbar', className: 'collapse navbar-collapse pull-right' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'nav navbar-nav' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/' },
	              'Home'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/#contact' },
	              'Contact'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAYAAAC9pNwMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjYzMzY0REY2MkZFMTFFQTkzNEJGMDVGNzcwNEYxM0MiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjYzMzY0RTA2MkZFMTFFQTkzNEJGMDVGNzcwNEYxM0MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGNjMzNjRERDYyRkUxMUVBOTM0QkYwNUY3NzA0RjEzQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGNjMzNjRERTYyRkUxMUVBOTM0QkYwNUY3NzA0RjEzQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoOR7wYAAAF3SURBVHja3FfBUcMwEJSZ8CYdoA5iKsBUEPgzg+nAJcQVQAcoMxSQDmIqwHTgdEDefLLH3EM+ZHEYOwncjMYjS9ZKp92VnJxe3j4YY1KjiI+X56tYO8ZaG124CYNmZpjQjlOdmAPFRM6ES99YRNpyFNsJjH0s+6LGvsX+Zz7wwVJ9NHusCqRthseUqzVSvB0NGGBneBSSJNzWELEwgeWgqWbQillrA13onUO/p5+suPbqTUQmqejnAjLJAV51rLyFkyhWey4mtMLANyIbtQe+0EhSk+prUS+EdrecESpTrQ9oyNVKMQbeBIxjOYaOrYIDf8dANMDvHasfHdg/rSyzXDL/jjSMMtcCJ8L+vpCnh5zIQi++sdmGWP3o3RxIEqVg7AYfOTaKT3mh/koTCJ2zPF4oWjhary5YVqknsdA9zWmlpWI1m0TGGWk67DBHv/vBTycGp20o93osikm8/WsD2cvVJ+fb4Bh/EmkM2P7SFrOjT/VOgAEAzF6I2cldyO0AAAAASUVORK5CYII="

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _BlogHeader = __webpack_require__(43);
	
	var _BlogHeader2 = _interopRequireDefault(_BlogHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'blog',
	          style: { margin: '0 auto', maxWidth: '70ch', marginBottom: '5em' }
	        },
	        _react2.default.createElement(
	          _Link2.default,
	          { href: '/blog/31-march' },
	          '\u2190 Previous'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Daily Debts'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'author' },
	          'by Jon Shulver, 14 April 2020'
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { fontStyle: 'italic' } },
	          '\u201CAnd forgive us our debts, as we also have forgiven our debtors.\u201D'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I\u2019m sure there are many things that we think we need right now. Many things the world needs. If we were to write down the needs, the list would be long. But as Jesus teaches his followers to pray to their Heavenly Father, the daily requests are few, and included is a request for forgiveness.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I suspect that forgiveness isn\u2019t something that many people feel they need each day. Some days \u2013 yes. But every day? That seems excessive. Maybe we feel like that too. After all, haven\u2019t we just celebrated Jesus\u2019 death and resurrection, which offers us complete forgiveness for all eternity? Why the need to daily seek God\u2019s forgiveness?'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'It\u2019s wonderfully true that Jesus\u2019 death and resurrection have paid the price for our sins. The debt that stood against us has been paid. The forgiving, atoning, redeeming work of Jesus was finished on the cross. We have joined God\u2019s family \u2013 forever. But, for now, our daily relationship with our Father is still affected by our sins. We want to live as children of God \u2013 but often we don\u2019t. We therefore seek his forgiveness when will fall short of living out our true identity.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'As the pastor Trevin Wax says \u201CThe prayer reminds us of our identity \u2013 people called and chosen by God to execute His forgiveness into everyday life. We should be breathing in and out forgiveness like air!\u201D Which is why Jesus links our forgiveness with our willingness to forgive others. The way we have been treated impacts the way we treat others. \u201CIf we think we\u2019ve accepted forgiveness from God but have refused that forgiveness to others, we have deceived ourselves. Failure to forgive communicates\u2026 I haven\u2019t been forgiven.\u201D'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Spending lots of time in a confined space with members of our households, having time to dwell on things said and done to us, feeling anxious: these experiences might all adversely impact our willingness to forgive others. Letting go of a debt isn\u2019t easy. But that\u2019s what forgiven people are called to do. It\u2019s who we are. It\u2019s what we do. We forgive our debtors.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Today, let\u2019s ask our Heavenly Father to forgive our debts, our sins. And let\u2019s be ready to forgive others. Not tomorrow \u2013 but today.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = BlogPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-329830e8b0b26aaa4933.js